import { createSlice } from '@reduxjs/toolkit';
import { processRequest } from './network/managedRequest';
import useSessionStorage, {
    LegacyUser,
    LegacyUserStore,
} from '../util/useSessionStorage';
import { API_SHORT } from '../constants';
import withLocalStorage from '../util/withLocalStorage';
import {
    LoadPartnerManagerDetails,
    LoadPartners,
    UnloadPartner,
} from './partnerManagerSlice';
import { PbDispatch, PbGetState } from './index';
import { GetOperationalContacts } from './operationalContactsSlice';
import { PbRequest } from './pbRequest';

const { getUserData, storeUserData } = useSessionStorage();
const { setUserLanguage } = withLocalStorage();

interface UserStore {
    legacyUser?: LegacyUser;
}

const initialState: UserStore = {
    legacyUser: undefined,
};

const LEGACY_STORE_TEMPLATE: LegacyUserStore = {
    user: null,
    error: false,
    loading: false,
};

const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        setLegacyUser(state, action) {
            state.legacyUser = { ...action.payload };
            storeUserData({ ...LEGACY_STORE_TEMPLATE, user: state.legacyUser });
            if (state.legacyUser?.lang) {
                setUserLanguage(state.legacyUser.lang);
            }
        },
    },
});

const { setLegacyUser } = userSlice.actions;

export function InitializeUser() {
    return (dispatch: PbDispatch) => {
        const data = getUserData();
        dispatch(setLegacyUser(data.user));
    };
}

export function LoadUser() {
    return async (dispatch: PbDispatch, getState: PbGetState) => {
        await LoadUserData(dispatch);
        await LoadPartnerManagerDetails()(dispatch);
        await LoadPartners()(dispatch, getState);
        await GetOperationalContacts()(dispatch);
    };
}

export function UnloadUser() {
    return async (dispatch: PbDispatch) => {
        await UnloadPartner()(dispatch);
    };
}

async function LoadUserData(dispatch: PbDispatch) {
    const user = await processRequest<LegacyUser>(
        dispatch,
        `${API_SHORT}/v1/users/me`,
        {},
        PbRequest.GET_USER_DATA
    );
    dispatch(setLegacyUser(user));
    return user;
}

export default userSlice.reducer;
